export const G_BUSTED_STATES = {
  INIT: 'init',
  WAIT: 'wait',
  START: 'start',
  CRASH: 'crash',
}
export const G_BUSTED_BID_STATUS = {
  LIVE: 'live',
  CLOSED: 'closed',
  BUSTED: 'busted',
}

export const G_BUSTED_SOCKET_CHANNELS = {
  WAIT: G_BUSTED_STATES.WAIT,
  START: G_BUSTED_STATES.START,
  CRASH: G_BUSTED_STATES.CRASH,
  BIDS: 'bids',
  GAME_STATUS: 'gameStatus',
  BET: 'bet',
  CASHOUT: 'cashout',
}
